import React from 'react'
import FileUpload from '../../elements/form/FileUpload'
import ModalActionButton from '../../elements/ModalActionButton'

const UploadStaffDocument = ({documentType, returnFile, close}) => {
    const validationErrors = {}
    const [file, setFile] = React.useState(null)

    return (
        <div className="w-full">
            <div className='mt-2 w-full'>
                <FileUpload
                    hasError={validationErrors.file}
                    fieldLabel={`Upload ${documentType}`}
                    returnFileDetails={(details)=>{
                        setFile(details)
                    }}
                    acceptedFormats={['pdf', 'png', 'jpeg', 'jpg']}
                />
                <label className='block mt-3 text-xs text-gray-400'>{`Upload a ${documentType} for your profile`}</label>
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Upload ${documentType}`}
                    buttonAction={()=>{
                        returnFile(file)
                        close()
                    }}
                    processing={false}
                />

                <button
                    type="button"
                    className="inline-flex font-space-grotesk justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary/40 focus:outline-none"
                    onClick={()=>{close()}}
                >
                    Close
                </button>
                    
            </div>
        </div>
    )
}

export default UploadStaffDocument